import React from 'react';
import {worldMapsSvg} from '../../components/public_directory/interactiveSvgData.js';

/** Decorative, local SVG geography: only Nigeria is an actionable territory.
 * No fabricated global client locations, routes, or heat intensity. */
export default function CEOFlatWorldPreview({onExploreNigeria}) {
  return <div className="ugi-ceo-flat-map">
    <svg viewBox="80 210 850 430" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet">
      <defs><linearGradient id="ugi-ceo-flat-fill" x1="0" y1="0" x2="1" y2="1"><stop stopColor="#6fb5ed" stopOpacity=".88"/><stop offset="1" stopColor="#2c6da8" stopOpacity=".65"/></linearGradient></defs>
      {worldMapsSvg.map((region,index)=><path key={index} d={region.d} fill="url(#ugi-ceo-flat-fill)" stroke="#9ddaff" strokeOpacity=".18" strokeWidth=".55"/>) }
    </svg>
    <button type="button" className="ugi-ceo-flat-action" onClick={onExploreNigeria}>⌖ Nigeria · Open state map <span aria-hidden="true">↗</span></button>
  </div>;
}
